import { render } from "./EditClientView.vue?vue&type=template&id=9de28a72&scoped=true"
import script from "./EditClientView.vue?vue&type=script&lang=js"
export * from "./EditClientView.vue?vue&type=script&lang=js"

import "./EditClientView.vue?vue&type=style&index=0&id=9de28a72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9de28a72"]])

export default __exports__